import MapInformation from './map-information';

export default MapInformation;
export { MapInformation };
